import { Box, Button, Icon, EasyPopover, Checkbox, ConfirmationDialog } from "@tm/components"
import { ERIKContentService } from "@tm/data"
import { useLocalization } from "@tm/localization"
import { useFileDownload, useFileDelete } from "../../hooks"
import { stopPropagation } from "../../helpers"
import FileShare from "../fileShare/FileShare"

type FileItemActionsProps = {
    file: ERIKContentService.FileMeta
    isSelected: boolean
    selectFile: (file: ERIKContentService.FileMeta, checked: boolean) => void
    deleteDialogOpen: boolean
    setDeleteDialogOpen: (isOpen: boolean) => void
}

export function FileItemActions({ file, isSelected, selectFile, deleteDialogOpen, setDeleteDialogOpen }: FileItemActionsProps) {
    const { downloadFile } = useFileDownload()
    const { translateText } = useLocalization()
    const { deleteFile } = useFileDelete()

    const handleDelete = () => {
        setDeleteDialogOpen(false)
        deleteFile(file.id)
    }

    return (
        <>
            <Box display="flex" gap="1em">
                <Button startIcon={<Icon name="download" />} onClick={stopPropagation(() => downloadFile(file))} />
                <EasyPopover anchorOrigin={{ vertical: "bottom", horizontal: "right" }} transformOrigin={{ horizontal: "right", vertical: "top" }}>
                    <EasyPopover.ActionButton>
                        <Button startIcon={<Icon name="share" />} onClick={stopPropagation((e) => {})} />
                    </EasyPopover.ActionButton>
                    <EasyPopover.Content sx={{ padding: "1em" }}>
                        <FileShare file={file} />
                    </EasyPopover.Content>
                </EasyPopover>
                <Button startIcon={<Icon name="delete" />} onClick={stopPropagation(() => setDeleteDialogOpen(true))} />
                <Checkbox checked={isSelected} onClick={stopPropagation()} onChange={(_e, checked) => selectFile(file, checked)} />
            </Box>
            <ConfirmationDialog
                open={deleteDialogOpen}
                confirmationButtonText={translateText(585)}
                cancelButtonText={translateText(584)}
                onOutsideClick={() => setDeleteDialogOpen(false)}
                onConfirm={() => handleDelete()}
                onCancel={() => setDeleteDialogOpen(false)}
            >
                {translateText(translateText(833))}
            </ConfirmationDialog>
        </>
    )
}
